export const sanityLocaleMap = (pagelang) => {
  return pagelang?.toLocaleLowerCase()
  .replace('_', '-')
  .replace('ja', 'jp')
  .replace('gb', 'uk')
  .replace('ko-kr', 'ko-ko')
  .replace('nb-no', 'no-no');
}